import { ReactNode } from 'react';
import { Stack } from '@prenuvo/halo';

interface DocumentRowContainerProps {
  children: ReactNode;
}

export function DocumentRowContainer({ children }: DocumentRowContainerProps) {
  return (
    <Stack
      alignment="center"
      className="w-full border-b border-neutral-600 py-2 pl-6"
      justification="between"
    >
      {children}
    </Stack>
  );
}
